import { stringify } from 'qs';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------
/**
 * RTK Query endpoints for the Analytics Embed API.
 *
 * Endpoints:
 * - `getAnalyticsFolder` – GET `/analytics/folders/default` → default analytics folder
 * - `getEmbedSsoUrl` – GET `/analytics/embedSsoUrl?{params}` → SSO embed URL
 *
 * Auth and tenant headers are handled by the base `ccApi`.
 */
export const analyticsApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        // -----------------------------------------------------------------------
        // Queries
        // -----------------------------------------------------------------------
        getAnalyticsFolder: builder.query({
            query: () => ({
                url: '/analytics/folders/default',
                method: 'GET',
            }),
            providesTags: [CC_API_TAGS.AnalyticsFolder],
        }),
        getEmbedSsoUrl: builder.query({
            query: (params) => ({
                // disabled encoding option as backend does not decode encoded slashes
                url: `/analytics/embedSsoUrl?${stringify(params)}`,
                method: 'GET',
            }),
            transformResponse: (response) => response.url,
        }),
    }),
});
export const { useGetAnalyticsFolderQuery, useLazyGetAnalyticsFolderQuery, useGetEmbedSsoUrlQuery, useLazyGetEmbedSsoUrlQuery, } = analyticsApi;
